import { useEffect } from 'react';
import InnerLayout from '../components/InnerLayout';

export default function TerminosCondiciones() {
  useEffect(() => { document.title = 'Términos y Condiciones — Sttora'; }, []);
  return (
    <InnerLayout titleFirst="Términos y" titleAccent="Condiciones" subtitle="Condiciones de uso de la plataforma y servicios Sttora." breadcrumb="Términos y Condiciones">
      <div className="legal-updated">Última actualización: Enero 2026</div>
      <div className="legal-content">
        <p>Al acceder y usar la plataforma Sttora, aceptas quedar vinculado por estos Términos y Condiciones. Si no estás de acuerdo, no debes utilizar nuestros servicios.</p>
        <h2>Uso de la Plataforma</h2>
        <p>La plataforma Sttora está destinada a usuarios mayores de 18 años o con la capacidad legal requerida en su jurisdicción. Te comprometes a usar los servicios únicamente para fines lícitos.</p>
        <h2>Registro de Cuenta</h2>
        <ul>
          <li>Debes proporcionar información veraz y actualizada durante el registro</li>
          <li>Eres responsable de mantener la confidencialidad de tus credenciales</li>
          <li>Sttora no es responsable por accesos no autorizados derivados de negligencia del usuario</li>
        </ul>
        <h2>Productos y Servicios</h2>
        <p>Los precios y disponibilidad de productos están sujetos a cambios sin previo aviso. Sttora se reserva el derecho de cancelar pedidos en caso de errores de precio, disponibilidad u otras circunstancias excepcionales.</p>
        <h2>Pagos</h2>
        <p>Los pagos se procesan a través de plataformas seguras certificadas. Sttora no almacena datos completos de tarjetas de crédito o débito.</p>
        <h2>Propiedad Intelectual</h2>
        <p>Todo el contenido de la plataforma es propiedad de Sttora o sus licenciantes. No está permitida su reproducción sin autorización expresa.</p>
        <h2>Modificaciones</h2>
        <p>Sttora puede modificar estos términos en cualquier momento. Las modificaciones entrarán en vigor al ser publicadas en la plataforma.</p>
        <h2>Contacto</h2>
        <p>Para consultas sobre estos términos: <a href="mailto:legal@sttora.com">legal@sttora.com</a></p>
      </div>
    </InnerLayout>
  );
}
